<script setup lang="ts">
import { useOrderStore } from '../../stores/order'
import { useWidgetStore } from '../../stores/widget-store'

const { propStateInQuery } = useQueryProp()

const widgetStore = useWidgetStore()

const orderStore = useOrderStore()

const route = useRoute()
const { $get, $post } = useApi()

const eventId = route.params.id as string

if (orderStore.event && orderStore.event !== eventId) {
  orderStore.clearCart()
}

const event = await $get(`/api/v1/event/${eventId}`)

const { tariff } = await useOrgTariff(event?.organization?.id as string)

const { data: user } = await useAsyncData<any>(
  `get user by widgetStore.token ${widgetStore.token}`,
  () => $get('/api/v1/auth', { headers: { Authorization: widgetStore.token } }),
  { default: () => null }
)

const showPage = computed(() => {
  if (
    (event &&
      event.scheduleInfo.saleStatus === 'opened' &&
      tariff &&
      tariff.features.onlineSales &&
      (!user.value || (user.value && user.value.role === 'client'))) ||
    (tariff &&
      tariff.features.offlineSales &&
      user.value &&
      (user.value.role === 'merchant' || user.value.role === 'agent'))
  ) {
    return true
  }
  return false
})

const commission = computed(() => {
  if (
    tariff &&
    tariff.features.onlineSales &&
    (!user.value || (user.value && user.value.role === 'client'))
  ) {
    return tariff.percentage.online.value
  } else if (
    tariff &&
    tariff.features.offlineSales &&
    user.value &&
    (user.value.role === 'merchant' || user.value.role === 'agent')
  ) {
    return tariff.percentage.offline.value
  }
  return 0
})

const saleEnding = new Date(event.scheduleInfo.saleEnding)
const now = new Date()

if (now > saleEnding) {
  await navigateTo(propStateInQuery('/'))
}

if (event.scheduleInfo.saleStatus === 'closed')
  // TODO: страница для закрытых продаж
  await navigateTo(propStateInQuery('/'))

orderStore.setEvent(eventId as string)

const isPendingOrderCreation = ref(false)

async function createOrder() {
  if (isPendingOrderCreation.value) return
  isPendingOrderCreation.value = true
  // @ts-ignore
  ym(95432634, 'reachGoal', 'selectplaces')
  console.log(user.value)
  try {
    try {
      if (user.value) {
        const order = await $post(
          `/api/v1/order/create-${user.value.role}-order`,
          {
            event: orderStore.event,
            cart: Array.isArray(orderStore.cart)
              ? orderStore.cart
              : typeof orderStore.cart === 'object'
              ? Object.values(orderStore.cart)
              : orderStore.cart
          },
          { headers: { Authorization: widgetStore.token, 'x-organization-id': widgetStore.orgId } }
        )

        const isInIframe = window.frameElement !== null;
        if (!isInIframe) {
          if (widgetStore.returnUrl)
            await navigateTo(`${widgetStore.returnUrl}/${order.id}`, { external: true })
          else await navigateTo(propStateInQuery(`/${order.id}/order`))
        } else {
          window.parent.postMessage({
            type: 'order-created',
            orderId: order.id
          }, '*')
        }
      } else {
        await navigateTo(propStateInQuery(`/${eventId}/user-info-form`))
      }
    } catch (error) {
      console.error(error)
      if (error?.response?.data?.message === 'Данные места уже заняты') {
        alert(error?.response?.data?.message)
        location.reload()
      } else {
        await navigateTo(propStateInQuery(`/${eventId}/user-info-form`))
      }
    }
  } catch (error) {
    alert(error?.response?.data?.message)
    location.reload()
  } finally {
    isPendingOrderCreation.value = false
  }
}
</script>

<template>
  <bw-wrapper v-if="showPage">
    <bw-canvas-schema
      v-if="event.tariff.type === 'canvas'"
      :event="event"
      :loading="isPendingOrderCreation"
      :create-order="createOrder"
      :settings="tariff"
      :commission="commission"
    />
    <bw-entrance-schema
      v-else-if="event.tariff.type === 'entrance'"
      :event="event"
      :loading="isPendingOrderCreation"
      :create-order="createOrder"
      :settings="tariff"
      :commission="commission"
    />
    <div v-else>
      error
    </div>
  </bw-wrapper>
</template>

<style scoped>
#scrollBlock {
  overflow-x: scroll;
  max-width: 100%;
}

#scrollBlock::-webkit-scrollbar {
  height: 2px;
  width: 7px !important;
  border-radius: 9px !important;
}

#scrollBlock::-webkit-scrollbar-track {
  background-color: #fefefe;
}

#scrollBlock::-webkit-scrollbar-thumb {
  width: 7px;
  border-radius: 9px;
  background-color: #0575dd;
}
</style>
